"use client";

import React from "react";

import { Layout } from "../../components/layout/Layout";
import { RegistrationSteps } from "../../components/RegistrationSteps";

export default function SignUpPage() {
	return (
		<Layout>
			<div className="flex flex-col items-center gap-20 py-16">
				<RegistrationSteps />
			</div>
		</Layout>
	);
}
